module.exports = __webpack_public_path__ + "static/media/1169363.11f83ad7.svg";